import IN_STORE from './in-store'
import OUT_STORE from './out-store'
import STOCK_PLAN from './stock-plan'
export default {
	'assign-manage': {
		id: 'assign-manage',
		label: '分派管理',
		code: '0004_0005',
		child: {
			...IN_STORE,
			...OUT_STORE,
			...STOCK_PLAN
		}
	}
}
